import React, {useState} from 'react';
import {Form} from 'react-bootstrap';
import {PfButton} from '@profabric/react-components';
import { toast } from 'react-toastify';

export default function ModalResetPassword(props) {
  const [password, setPassword] = useState("");

  const handleReset = async () => {
    try {
      if(password === ""){
        toast.error("ห้ามเป็นค่าว่าง");
      }else{
        const result = await props.onReset(props.item.CARD_ID, password);
      }
    } catch (error) {}
  };
  return (
    <div>
      <Form>
        <div className="row">
          <Form.Group className="mb-3 col-md-12">
            <Form.Control
              type="text"
              onChange={(event) => {
                setPassword(event.target.value);
              }}
              placeholder="ใส่รหัสผ่านใหม่ (ตัวเลข/อักษรภาษาอังกฤษ)"
            />
          </Form.Group>
        </div>
      </Form>
      <PfButton
        className={'d-inline mr-1 col-5'}
        theme="success"
        block
        type="button"
        onClick={handleReset}
      >
        ตั้งรหัสใหม่
      </PfButton>
    </div>
  );
}
